import React from 'react';
import './Header.scss';
import HeaderSearchInput from './HeaderSearchInput.jsx';

const HeaderTopMenu = ({ topMenuModel, searchPlaceholderText, searchAccessibilityText }) => {
  return (
    <nav>
      <h2 className="sr-only">
        <span>Main navigation</span>
      </h2>
      <ul className="flex flex-row justify-end mt-5">
        {topMenuModel?.items?.map(item => (
          <li className="ml-[10px] text-[14px]" key={item.id}>
            <a href={item.url} className="text-blue-800">{item.title}</a>
          </li>
        ))}
        <li className="ml-[10px] text-[14px]">
          <HeaderSearchInput searchPlaceholderText={searchPlaceholderText} searchAccessibilityText={searchAccessibilityText} />
        </li>
      </ul>
    </nav>
  );
};

export default HeaderTopMenu;